var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureDeliveryImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.746,
    height: 30.688,
    viewBox: "0 0 30.746 30.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delivery",
    transform: "translate(-1231.276 -1643.904)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6273",
    "data-name": "Path 6273",
    d: "M1248.282,1644.269v5.264l-.135.146a1.415,1.415,0,0,1-.615.27,9.522,9.522,0,0,0-3.846,2.081c-.644.54-.68.54-1.647,0-.4-.228-.968-.539-1.26-.7a27.831,27.831,0,0,1-2.521-1.436.544.544,0,0,1-.105-.346c0-.2.053-.3.416-.721a14.648,14.648,0,0,1,3.365-2.819,15.26,15.26,0,0,1,4.971-1.946c.774-.165,1.014-.152,1.225.059Z",
    transform: "translate(-3.307 -0.022)",
    fill: "#28a745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6274",
    "data-name": "Path 6274",
    d: "M1268.842,1647.939c-.312.4-.634.827-.721.938-.492.662-1.125,1.454-1.2,1.518-.152.129-.451.094-1.031-.123-.305-.111-.774-.264-1.043-.339a1.633,1.633,0,0,1-.616-.282l-.129-.14v-2.626c0-2.545.006-2.632.118-2.756a.907.907,0,0,1,.235-.182c.17-.071.193-.064.949.094a15.645,15.645,0,0,1,3.7,1.231c.839.41.979.528.979.844C1270.078,1646.344,1270.1,1646.31,1268.842,1647.939Z",
    transform: "translate(-15.783 0)",
    fill: "#28a745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6275",
    "data-name": "Path 6275",
    d: "M1282.708,1665.456a17.127,17.127,0,0,1-1.02,3.652,15.5,15.5,0,0,1-2.257,3.746c-.2.223-.252.258-.475.258-.281,0-.276,0-1.383-1.289-.358-.422-.979-1.143-1.379-1.606s-.773-.9-.838-.985c-.176-.229-.14-.527.106-.915a10.676,10.676,0,0,0,1.354-3.441,11.783,11.783,0,0,0,.064-3.077,9.223,9.223,0,0,0-1.888-4.525c-.411-.551-.469-.68-.381-.9.053-.135,2.5-3.359,2.966-3.91a.887.887,0,0,1,.34-.27c.276-.047.428.035.85.469a15.386,15.386,0,0,1,3.945,8.282A19.269,19.269,0,0,1,1282.708,1665.456Z",
    transform: "translate(-20.821 -3.981)",
    fill: "#28a745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6276",
    "data-name": "Path 6276",
    d: "M1255.416,1679.608c-.042.263-.106.334-.651.686a15.425,15.425,0,0,1-6.184,2.228,15.025,15.025,0,0,1-6.917-.71,15.439,15.439,0,0,1-9.573-9.579,14.482,14.482,0,0,1-.815-5.011,15.118,15.118,0,0,1,.639-4.631c.4-1.372.633-1.87.92-1.922.24-.041.434.046,2.175,1,2.6,1.424,2.5,1.372,2.626,1.583l.111.187-.211.715a9.711,9.711,0,0,0,.569,7.269,8.927,8.927,0,0,0,1.794,2.456,9.427,9.427,0,0,0,3.171,2.122,8.716,8.716,0,0,0,3.283.668,9.31,9.31,0,0,0,4.824-1.084c.445-.229.534-.258.7-.211.147.047.475.387,1.524,1.607C1255.439,1679.35,1255.457,1679.368,1255.416,1679.608Z",
    transform: "translate(0 -8.057)",
    fill: "#28a745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6277",
    "data-name": "Path 6277",
    d: "M1261.552,1662.318v10.434l-.164.158-.158.164H1259l-.158-.164-.164-.158v-5.211c0-5.129,0-5.211.117-5.34a.92.92,0,0,1,.235-.182,7.812,7.812,0,0,1,1.155-.035l1.044.011.158.164Z",
    transform: "translate(-13.177 -8.693)",
    fill: "#28a745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6278",
    "data-name": "Path 6278",
    d: "M1253.648,1669.092v6.917l-.165.158-.158.164H1251.1l-.158-.164-.164-.158v-3.452c0-3.371,0-3.453.117-3.582a.917.917,0,0,1,.235-.182,7.953,7.953,0,0,1,1.155-.035l1.044.011.158.164Z",
    transform: "translate(-9.376 -11.95)",
    fill: "#28a745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6279",
    "data-name": "Path 6279",
    d: "M1269.455,1673.609v4.572l-.164.158-.159.164h-2.228l-.158-.164-.165-.158V1675.9c0-2.2.006-2.286.118-2.409a.891.891,0,0,1,.234-.182,7.919,7.919,0,0,1,1.155-.035l1.043.012.159.164Z",
    transform: "translate(-16.977 -14.122)",
    fill: "#28a745"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureDeliveryImg);
export default __webpack_public_path__ + "static/media/feature-delivery-img.30ef56aa6dbe14cae94c28aeb476bd31.svg";
export { ForwardRef as ReactComponent };